// A single logout path for expired and explicitly ended sessions.
// Keep storage behavior identical to the existing client until session
// persistence is intentionally redesigned.
let sessionExitInProgress = false

export const endSession = (): void => {
  if (sessionExitInProgress) return
  sessionExitInProgress = true
  localStorage.clear()
  window.location.reload()
}
